<script setup>
import GuidanceComponent from "../../layouts/components/Notice.vue";
import HeadlineComponent from "./Headline.vue";
import {inject} from "vue";
import utilHelper from "../../app/utilHelper";
const {getMailBody} = utilHelper();

const props = defineProps({
    title: String,
    message: String,
    itemPurchaseDetails: String,
    selections: Array,
    image: {
        type: String,
        required: false,
        default: null
    },
    inputValues: Object,
    keyFirstSetOrder: {
        type: Object,
        required: false,
        default: () => ({})
    },
    sendMailAddress: String,
    showConfirm: {
        type: Boolean,
        required: false,
        default: true
    },
    showAppleBillingDetailGuide: {
        type: Boolean,
        required: false,
        default: true
    },
    previousIndex: Number,
});

const PROJECT_NAME = inject('PROJECT_NAME');
const SUBJECT = PROJECT_NAME + '【ログイン】';

function getUrlEncodeText(text) {
    return encodeURIComponent(text);
}


const BILLING_DETAIL_APPLE_HTML = inject('BILLING_DETAIL_APPLE_HTML');
const BILLING_DETAIL_AMAZON_HTML = inject('BILLING_DETAIL_AMAZON_HTML');
const CONTACT_MAIL_ADDRESS = inject('CONTACT_MAIL_ADDRESS');
const code = inject('code', '');
const index = inject('index');

</script>

<template>
    <div class="uk-margin-small-left uk-margin-small-right uk-flex-1">
        <div class="uk-flex uk-flex-column uk-height-1-1">
            <headline-component v-if="props.title" :title="props.title"/>
            <div id="guidance-wrapper" class="uk-flex-1 uk-margin uk-flex uk-flex-column uk-overflow-auto uk-flex-center">
                <div class="uk-width-1-1" style="overflow-y: scroll;">
                    <div>
                        以下の「メーラーを起動」を選択するとメール送信画面が起動します。<br>
                        ご準備いただいた「{{ props.itemPurchaseDetails }}」を
                        確認できる<span style="color: red;">スクリーンショットをメールに添付して送信してください。</span>
                        <br>
                        <br>
                        <!-- Apple 購入明細案内: showAppleBillingDetailGuide で表示制御 -->
                        <template v-if="showAppleBillingDetailGuide">
                            <ul uk-accordion>
                                <li>
                                    <a class="uk-accordion-title" href>Appleの購入明細の確認方法</a>
                                    <div class="uk-accordion-content">
                                        <guidance-component :message="BILLING_DETAIL_APPLE_HTML"></guidance-component>
                                    </div>
                                </li>
                            </ul>
                            <br>
                        </template>
                        <ul uk-accordion>
                            <li>
                                <a class="uk-accordion-title" href>Amazonの購入明細の確認方法</a>
                                <div class="uk-accordion-content">
                                    <guidance-component :message="BILLING_DETAIL_AMAZON_HTML"></guidance-component>
                                </div>
                            </li>
                        </ul>
                        <br>
                        <span style="color: red;">※購入明細が確認できると、アカウント復旧のご案内がスムーズに行えます</span>

                    </div>
                </div>
            </div>
            <div class="uk-margin uk-flex">
                <div class="uk-flex-1">
                    <router-link :to="'/form/' + previousIndex">
                        <button class="uk-button uk-button-default uk-border-rounded uk-margin-auto uk-width-auto">戻る</button>
                    </router-link>
                </div>
                <template v-if="selections.length > 0" v-for="selection in selections">
                    <div class="uk-flex-1">
                        <router-link :to="'/form/' + selection.index">
                            <button
                                class="uk-button uk-button-primary uk-border-rounded uk-margin-auto uk-width-auto"
                                @click="$emit('changeIndex')">{{ selection.text }}
                            </button>
                        </router-link>
                    </div>
                </template>
                <template v-else>
                    <div class="uk-flex-1">
                        <a :href="'mailto:' + CONTACT_MAIL_ADDRESS + '?subject=' + getUrlEncodeText(SUBJECT) + '&body=' + getUrlEncodeText(getMailBody(true, inputValues, code, keyFirstSetOrder))">
                            <button class="uk-button uk-button-primary uk-border-rounded uk-margin-auto uk-width-auto"
                                    @click="$emit('sendMail')">
                                メーラーを起動
                            </button>
                        </a>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<style scoped>
#guidance-wrapper {
    align-items: center;
    > div {
        padding: 20px;
        white-space: pre-wrap;
        text-align: left !important;
    }
}
</style>